import { useEffect, useState } from "react";
import { Server, User, Package } from "lucide-react";
import api from "@/lib/api";
import { AppLayout } from "@/components/AppLayout";
import { SecurityPanel } from "@/components/SecurityPanel";
import { HygienePanel } from "@/components/HygienePanel";
import { useAuth } from "@/context/AuthContext";

export default function Settings() {
  const { user } = useAuth();
  const [info, setInfo] = useState(null);
  const [me, setMe] = useState(null);

  useEffect(() => {
    api.get("/system/info").then((r) => setInfo(r.data)).catch(() => {});
    api.get("/auth/me").then((r) => setMe(r.data)).catch(() => {});
  }, []);

  return (
    <AppLayout>
      <h1 className="font-display text-3xl font-semibold tracking-tight">Settings</h1>
      <p className="mt-1 text-sm text-muted-foreground">Account, platform, and deployment.</p>

      <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
        <section className="rounded-lg border border-border bg-card p-6">
          <div className="mb-4 flex items-center gap-2 text-muted-foreground">
            <User className="h-4 w-4" />
            <p className="text-xs font-semibold uppercase tracking-widest">Account</p>
          </div>
          <dl className="space-y-3 text-sm">
            <div className="flex justify-between"><dt className="text-muted-foreground">Name</dt><dd data-testid="settings-name">{user?.name}</dd></div>
            <div className="flex justify-between"><dt className="text-muted-foreground">Email</dt><dd className="font-mono">{user?.email}</dd></div>
            <div className="flex justify-between"><dt className="text-muted-foreground">Role</dt><dd className="capitalize">{user?.role}</dd></div>
          </dl>
        </section>

        <section className="rounded-lg border border-border bg-card p-6">
          <div className="mb-4 flex items-center gap-2 text-muted-foreground">
            <Server className="h-4 w-4" />
            <p className="text-xs font-semibold uppercase tracking-widest">Platform</p>
          </div>
          {info ? (
            <dl className="space-y-3 text-sm">
              <div className="flex justify-between"><dt className="text-muted-foreground">Version</dt><dd className="font-mono">{info.version}</dd></div>
              <div className="flex justify-between"><dt className="text-muted-foreground">Backend</dt><dd>{info.stack.backend}</dd></div>
              <div className="flex justify-between"><dt className="text-muted-foreground">Database</dt><dd>{info.stack.database}</dd></div>
              <div className="flex justify-between"><dt className="text-muted-foreground">LLM</dt><dd className="font-mono">{info.llm.provider}/{info.llm.model}</dd></div>
            </dl>
          ) : (
            <p className="text-sm text-muted-foreground">Loading…</p>
          )}
        </section>

        <SecurityPanel me={me} />

        <HygienePanel />

        <section className="rounded-lg border border-border bg-card p-6 lg:col-span-2">
          <div className="mb-3 flex items-center gap-2 text-muted-foreground">
            <Package className="h-4 w-4" />
            <p className="text-xs font-semibold uppercase tracking-widest">Self-Host / Deploy</p>
          </div>
          <p className="max-w-2xl text-sm text-muted-foreground">
            This instance is deployed from your GitHub repository. Push to <span className="font-mono">main</span>,
            then run your deploy script on the server to roll the new build out.
          </p>
        </section>
      </div>
    </AppLayout>
  );
}
